export const CuratedArticlesQuery = `
  query curation($first: Int, $where: ArticleCurationWhereUniqueInput!) {
    values: articleCuration(where: $where) {
      id
      __typename
      createdAt
      updatedAt
      title
      slug
      article(first: $first) {
        id
        __typename
        heading
        slug
        image {
          id
          url
        }
      }
    }
  }
`;
